// extracted by mini-css-extract-plugin
export var arrow = "_cp-1";
export var content = "_cp-0";
export var highlighted = "_cp-2";